{
  "next": "Siguiente",
  "previous": "Anterior"
}
